module.exports = __webpack_public_path__ + "static/media/ragismeni-vera-writer.a59c660e.jpg";